// extracted by mini-css-extract-plugin
module.exports = {"title":"AddUser_title__3YBoU","actions":"AddUser_actions__1MnNL"};